import React, { useState, useEffect, useCallback } from 'react';
import { TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from 'redux-lib/actions/actions';
import GRAPHQL_API from 'api/graphql';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function CarYearSelect(props) {
  const classes = useStyles(); 
  const [ loading, setLoading ] = useState(false);
  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })

  const car_brand = states ? states.car_brand ? states.car_brand : "" : "";
  const car_model = states ? states.car_model ? states.car_model : "" : "";
  const car_year = states ? states.car_year ? states.car_year : "" : "";
  const car_year_options = states ? states.car_years ? states.car_years : [] : [];

  useEffect(() => {
    const q = `{ get_car_years(brand: "${ car_brand }", model: "${ car_model }") }`;
    setLoading(true)
    GRAPHQL_API.graph(q).then(data => {
      if( data ) {
        dispatch({
          type: ACTIONS.UPDATE_CAR_YEARS,
          payload: data.data.get_car_years
        })
      }
      setLoading(false)
    })
  }, [car_model, car_brand])

  const handleChange = (e, newValue) => {
    dispatch({
      type: ACTIONS.UPDATE_CAR_YEAR,
      payload: newValue
    })
    dispatch({
      type: ACTIONS.UPDATE_IS_ON_MANUAL_FMV,
      payload: false
    })
    const statesToClear = [
      'depreciation',
      'manual_fmv',
      'quotes',
      // 'selected_quotes'
    ];
    clearStates(statesToClear);
  }

  const clearStates = (statesToClear) => {
    statesToClear.forEach((state) => {
      let stateType = `UPDATE_${ state.toUpperCase() }`;
      let payload = ""
      if( state === 'quotes' || state === 'selected_quotes' ) {
        payload = [];
      }
      dispatch({
        type: stateType,
        payload: payload
      })
    })
  }

  return(
    <div className={ classes.root }>
      <Autocomplete
        id="autocomplete-car-year"
        options={car_year_options}
        getOptionLabel={(option) => option ? option : ""}
        getOptionSelected={(option, value) => option === value}
        onChange={handleChange}
        value={ car_year }
        loading={ loading }
        autoHighlight={true}
        loadingText="Loading..."
        autoSelect={true}
        noOptionsText={ `No Options` }
        renderInput={(params) => (
          <TextField
            { ...params }
            id="standard-select-car-year"
            name="car_year"
            label="Year"
            className={ classes.select }
            InputLabelProps={{
              shrink: true
            }}
          />
        )}
      />
    </div>
  )
}

export default CarYearSelect;